import React, { FC, useMemo } from "react";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import { WorkspaceSchema } from "@common/schemas/workspace.schema";
import { useIdCopy } from "@hooks/useIdCopy";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { CommandItem } from "@design-system/CommandItem/CommandItem";

interface Props {
    index: number;
    workspace: Pick<WorkspaceSchema, "id" | "name" | "entities">;
    onSelected(): void;
}

export const WorkspaceCommandItem: FC<Props> = ({
    workspace,
    index,
    onSelected,
}) => {
    const { getCopyProps } = useIdCopy({ label: "Workspace" });
    const entitiesToShow = useMemo(
        () => workspace.entities?.filter((e) => !!e.name) ?? [],
        [workspace.entities],
    );

    return (
        <CommandItem
            key={workspace.id}
            keywords={[
                "workspace",
                workspace.name,
                ...entitiesToShow.map((entity) => entity.name!),
            ]}
            onSelect={onSelected}
            shortcut={`o>${index + 1}`}
        >
            <KickLogo variant="icon" size="xs" />
            <div>
                Open{" "}
                <span {...getCopyProps(workspace.id)}>
                    {workspace.name}
                </span>{" "}
            </div>
            {entitiesToShow.length > 0 ? (
                <EntityAvatarGroup
                    entities={entitiesToShow}
                    max={entitiesToShow.length}
                    size="xs"
                />
            ) : null}
        </CommandItem>
    );
};
